import { api } from 'shared/api';

export const resetPasswordApi = api.injectEndpoints({
  endpoints: (build) => ({
    requestPasswordReset: build.mutation<void, { email: string }>({
      query: ({ email }) => ({
        url: `/reset/request?email=${encodeURIComponent(email)}`,
        method: 'POST',
      }),
    }),
    confirmPasswordReset: build.mutation<void, { token: string; email: string; password: string }>({
      query: ({ token, email, password }) => ({
        url: `/reset/${token}`,
        method: 'POST',
        body: { email, password },
      }),
    }),
  }),
});

export const { useRequestPasswordResetMutation, useConfirmPasswordResetMutation } = resetPasswordApi;
